var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { GalleryDisplayPossibilityOptions } from '../resources/gallery-display-possibility-options';
let SdsGalleryItemBase = (() => {
    var _a, _SdsGalleryItemBase_url_accessor_storage, _SdsGalleryItemBase_thumbUrl_accessor_storage, _SdsGalleryItemBase_identifier_accessor_storage, _SdsGalleryItemBase_isMainMode_accessor_storage, _SdsGalleryItemBase_displayOption_accessor_storage;
    let _classSuper = LitElement;
    let _url_decorators;
    let _url_initializers = [];
    let _url_extraInitializers = [];
    let _thumbUrl_decorators;
    let _thumbUrl_initializers = [];
    let _thumbUrl_extraInitializers = [];
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _isMainMode_decorators;
    let _isMainMode_initializers = [];
    let _isMainMode_extraInitializers = [];
    let _displayOption_decorators;
    let _displayOption_initializers = [];
    let _displayOption_extraInitializers = [];
    return _a = class SdsGalleryItemBase extends _classSuper {
            /**
             * The URL of the main content
             * @attr
             */
            get url() { return __classPrivateFieldGet(this, _SdsGalleryItemBase_url_accessor_storage, "f"); }
            set url(value) { __classPrivateFieldSet(this, _SdsGalleryItemBase_url_accessor_storage, value, "f"); }
            /**
             * The URL of the thumb content
             * @attr
             */
            get thumbUrl() { return __classPrivateFieldGet(this, _SdsGalleryItemBase_thumbUrl_accessor_storage, "f"); }
            set thumbUrl(value) { __classPrivateFieldSet(this, _SdsGalleryItemBase_thumbUrl_accessor_storage, value, "f"); }
            /**
             * The unique value of the item
             * @attr
             */
            get identifier() { return __classPrivateFieldGet(this, _SdsGalleryItemBase_identifier_accessor_storage, "f"); }
            set identifier(value) { __classPrivateFieldSet(this, _SdsGalleryItemBase_identifier_accessor_storage, value, "f"); }
            /**
             * The item is main mode or thumb
             * @attr
             */
            get isMainMode() { return __classPrivateFieldGet(this, _SdsGalleryItemBase_isMainMode_accessor_storage, "f"); }
            set isMainMode(value) { __classPrivateFieldSet(this, _SdsGalleryItemBase_isMainMode_accessor_storage, value, "f"); }
            get displayOption() { return __classPrivateFieldGet(this, _SdsGalleryItemBase_displayOption_accessor_storage, "f"); }
            set displayOption(value) { __classPrivateFieldSet(this, _SdsGalleryItemBase_displayOption_accessor_storage, value, "f"); }
            constructor() {
                super();
                _SdsGalleryItemBase_url_accessor_storage.set(this, __runInitializers(this, _url_initializers, ''));
                _SdsGalleryItemBase_thumbUrl_accessor_storage.set(this, (__runInitializers(this, _url_extraInitializers), __runInitializers(this, _thumbUrl_initializers, '')));
                _SdsGalleryItemBase_identifier_accessor_storage.set(this, (__runInitializers(this, _thumbUrl_extraInitializers), __runInitializers(this, _identifier_initializers, '')));
                _SdsGalleryItemBase_isMainMode_accessor_storage.set(this, (__runInitializers(this, _identifier_extraInitializers), __runInitializers(this, _isMainMode_initializers, void 0)));
                _SdsGalleryItemBase_displayOption_accessor_storage.set(this, (__runInitializers(this, _isMainMode_extraInitializers), __runInitializers(this, _displayOption_initializers, void 0)));
                __runInitializers(this, _displayOption_extraInitializers);
            }
            toDownloadContent() {
                this.dispatchEvent(new CustomEvent(_a.DOWNLOAD_EVENT, {
                    detail: {
                        value: this.identifier,
                    },
                    bubbles: false,
                    composed: false,
                }));
            }
            dispatchFullScreenEvent() {
                this.dispatchEvent(new CustomEvent(_a.FULL_SCREEN_EVENT, {
                    detail: null,
                    bubbles: false,
                    composed: false,
                }));
            }
            adjustItemSize() {
                if (this.offsetWidth > this.offsetHeight) {
                    this.style.height = `${this.parentNode.offsetWidth}px`;
                }
                else {
                    this.style.width = `${this.parentNode.offsetHeight}px`;
                }
            }
            get isInFullScreen() {
                return this.displayOption === GalleryDisplayPossibilityOptions.FULL;
            }
            get propertiesIsInvalid() {
                return isNil(this.url) || isNil(this.identifier) || isNil(this.contentType);
            }
            get correspondingUrl() {
                if (this.isMainMode) {
                    return this.url;
                }
                return this.thumbUrl || this.url;
            }
        },
        _SdsGalleryItemBase_url_accessor_storage = new WeakMap(),
        _SdsGalleryItemBase_thumbUrl_accessor_storage = new WeakMap(),
        _SdsGalleryItemBase_identifier_accessor_storage = new WeakMap(),
        _SdsGalleryItemBase_isMainMode_accessor_storage = new WeakMap(),
        _SdsGalleryItemBase_displayOption_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _url_decorators = [property({ type: String })];
            _thumbUrl_decorators = [property({ type: String, attribute: 'thumb-url', reflect: true })];
            _identifier_decorators = [property({ type: String })];
            _isMainMode_decorators = [property({ type: Boolean, attribute: 'is-main-mode', reflect: true })];
            _displayOption_decorators = [property({ type: String, attribute: 'display-option', reflect: true })];
            __esDecorate(_a, null, _url_decorators, { kind: "accessor", name: "url", static: false, private: false, access: { has: obj => "url" in obj, get: obj => obj.url, set: (obj, value) => { obj.url = value; } }, metadata: _metadata }, _url_initializers, _url_extraInitializers);
            __esDecorate(_a, null, _thumbUrl_decorators, { kind: "accessor", name: "thumbUrl", static: false, private: false, access: { has: obj => "thumbUrl" in obj, get: obj => obj.thumbUrl, set: (obj, value) => { obj.thumbUrl = value; } }, metadata: _metadata }, _thumbUrl_initializers, _thumbUrl_extraInitializers);
            __esDecorate(_a, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
            __esDecorate(_a, null, _isMainMode_decorators, { kind: "accessor", name: "isMainMode", static: false, private: false, access: { has: obj => "isMainMode" in obj, get: obj => obj.isMainMode, set: (obj, value) => { obj.isMainMode = value; } }, metadata: _metadata }, _isMainMode_initializers, _isMainMode_extraInitializers);
            __esDecorate(_a, null, _displayOption_decorators, { kind: "accessor", name: "displayOption", static: false, private: false, access: { has: obj => "displayOption" in obj, get: obj => obj.displayOption, set: (obj, value) => { obj.displayOption = value; } }, metadata: _metadata }, _displayOption_initializers, _displayOption_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        // Event Name
        _a.FULL_SCREEN_EVENT = 'sds.gallery-full-screen.change',
        _a.DOWNLOAD_EVENT = 'sds.gallery-download.click',
        _a;
})();
export { SdsGalleryItemBase };
